import { render } from "./tableLayout.vue?vue&type=template&id=79d5826d&scoped=true"
import script from "./tableLayout.vue?vue&type=script&lang=js"
export * from "./tableLayout.vue?vue&type=script&lang=js"

import "./tableLayout.vue?vue&type=style&index=0&id=79d5826d&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d5826d"]])

export default __exports__